import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3.js";

let API = {
  getRecurringGifts: (postData) =>
    new FnrFetch3("/give/getUserRecurringGifts", postData),
  getRecurringGiftDetails: (ID) =>
    new FnrFetch3("/give/getUserRecurringGiftDetails", { ID }),
  skip: (postData) => new FnrFetch3("/give/skipNextRecurringGift", postData),
  pause: (postData) => new FnrFetch3("/give/pauseRecurringGift", postData),
  delete: (postData) => new FnrFetch3("/give/deleteRecurringGift", postData),
  unpause: (postData) => new FnrFetch3("/give/unpauseRecurringGift", postData),
  getTotalAmount: (postData) =>
    new FnrFetch3("/give/getTotalAmountToBeGiven", postData),
  editRecurringGift: (postData) =>
    new FnrFetch3("/give/editRecurringGift", postData),
};

export default API;
